import styled from "styled-components";

export const Em = styled.em<{weight?:'bold' | 'default', error?:boolean}>`
    font-weight: ${props => props.weight === 'bold' ? 800 : 500};
    color:${props => props.error ? props.theme.colors.text.state.error : props.theme.colors.text.highlighted};
    font-style: normal;
`;